import { render, staticRenderFns } from "./RoleColorsLegend.vue?vue&type=template&id=9911f314&scoped=true&"
import script from "./RoleColorsLegend.vue?vue&type=script&lang=js&"
export * from "./RoleColorsLegend.vue?vue&type=script&lang=js&"
import style0 from "./RoleColorsLegend.vue?vue&type=style&index=0&id=9911f314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9911f314",
  null
  
)

export default component.exports